import React from "react";
import { format } from "date-fns";

import { SegmentView } from "@tiny/api";
import { Chip, TruncateTooltip, Typography } from "@tiny/components";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import { isPredefinedSegment } from "../SegmentList.helpers";

interface SegmentItemProps {
  item: SegmentView;
}

const DATE_FORMAT = "d MMM, yy - h:mm aa";

function SegmentItem(props: SegmentItemProps) {
  const { item } = props;

  const { mdUp } = useBreakpoints();

  return (
    <div>
      {mdUp ? (
        <TruncateTooltip>
          <Typography
            variant="label1"
            color="grey"
            tone={800}
            display="block"
            mb={1}
            noWrap
          >
            {item.name}
          </Typography>
        </TruncateTooltip>
      ) : (
        <Typography
          variant="label1"
          color="grey"
          tone={800}
          display="block"
          mb={1}
        >
          {item.name}
        </Typography>
      )}
      {item.segmentType === "CUSTOM" && (
        <Chip label="Custom" color="blue" size="small" />
      )}
      {isPredefinedSegment(item.segmentType) && (
        <Chip label="Predefined" color="purple" size="small" />
      )}
      <Typography variant="body3" color="grey" tone={700}>
        Created {format(new Date(item.createdAt!), DATE_FORMAT)}
      </Typography>
    </div>
  );
}

export default SegmentItem;
